import { render, staticRenderFns } from "./ConfirmedEmail.vue?vue&type=template&id=5d2000e2&"
import script from "./ConfirmedEmail.vue?vue&type=script&lang=js&"
export * from "./ConfirmedEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports